import { Pipe, PipeTransform } from "@angular/core";
import { TileChip } from "@claimssummaryshared/models/claims-landing/tilechip.interface";

@Pipe({
  name: "claFeatureTileChip",
  standalone: false,
})
export class FeatureTileChipsPipe implements PipeTransform {
  transform(tileChip: TileChip): string {
    return tileChip.description.join("\n");
  }
}
